import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const CustomersAndOrdersViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminEmbeddedCxAdminAppView],
  },
]

export const CustomerDetailViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminCustomersDetailsView],
  },
]

export const OrderDetailViewAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.customersAndOrdersOrderDetailView],
    // TODO: Change to specific order details permission once it's added
    permissions: [Permission.CareAdminEmbeddedCxAdminAppView],
  },
]

// Gates the appeasement actions (refund; credit/redelivery coming soon) in the "Manage order" menu.
// Layered on top of the order detail page's own view gate: the page is already toggle-gated (and
// redirects to legacy without it), so this only adds the create permission that separates viewing an
// order from issuing a refund.
export const OrderAppeasementsAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CareAdminOrdersAppeasementsCreate],
  },
]

// Gates the order history tab on the customer detail page — shows the list of past orders.
export const CustomerOrderHistoryViewAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.customersAndOrdersCustomerOrderHistoryView],
    permissions: [Permission.CareAdminCustomersOrdersView],
  },
]

// Gates the IPP customer search page. Users without this permission are redirected to the embedded legacy cx-admin search instead.
export const CustomerSearchViewAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.customersAndOrdersCustomerSearchView],
    permissions: [Permission.CareAdminCustomersSearchView],
  },
]

// Gates the double-F keyboard shortcut that opens the fast-find search modal from anywhere in the portal.
export const CustomerSearchFastFindAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.customersAndOrdersCustomerSearchView],
    permissions: [Permission.CareAdminCustomersSearchFastFind],
  },
]

// Gates the "recently visited" customers section shown on the search landing page.
export const CustomerSearchLatestAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.customersAndOrdersCustomerSearchView],
    permissions: [Permission.CareAdminCustomersSearchLatest],
  },
]
